import { TOKEN_KEY } from "./apiService";
import  apiService  from "../services/apiService";
import { jwtDecode } from "jwt-decode";
const USER_KEY = "user";
const authService = {   
 
// SEND LOGIN OTP  
sendLoginOtp: (login) => {
  const fd = new FormData();
  fd.append("login", login);
  return apiService.create("auth/login-send-otp", fd);
},
// VERIFY LOGIN OTP  
verifyLoginOtp: async (login, otp) => {
  const fd = new FormData();
  fd.append("login", login);
  fd.append("otp", otp);
  const response = await apiService.create("auth/login-verify-otp", fd);
  const { access_token, user } = response.data;
  if (!access_token || !user) {
    throw new Error("Invalid OTP login response");
  }
  localStorage.setItem(TOKEN_KEY, access_token);
  localStorage.setItem("user", JSON.stringify(user));
  return response.data;
},
  
 // ✅ REQUEST RESET PASSWORD OTP
requestPasswordResetOtp: (login) => {
  const fd = new FormData();
  fd.append("login", login);
  return apiService.create("auth/password/request-otp", fd);
},
// ✅ RESET PASSWORD
resetPassword: ({ login, otp, password, password_confirmation }) => {
  const fd = new FormData();
  fd.append("login", login);
  fd.append("otp", otp);
  fd.append("password", password);
  fd.append("password_confirmation", password_confirmation);
  return apiService.create("auth/password/reset", fd);
},
 adminLogin: async (credentials) => {
  const response = await apiService.create("auth/admin-login", credentials);
  const { access_token, user, message } = response.data;
  if (!access_token || !user) {
    throw new Error("Invalid admin login response");
  }
  localStorage.setItem(TOKEN_KEY, access_token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return { access_token, user, message };
},
  getToken: () => localStorage.getItem(TOKEN_KEY),
login: async (credentials) => {
  const response = await apiService.create("auth/login", credentials);
  const { access_token, user } = response.data;
  if (!access_token || !user) {
    throw new Error("Invalid login response");
  }
  localStorage.setItem(TOKEN_KEY, access_token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return response.data;
},
logout: async () => {
  const response = await apiService.create("auth/logout", {});
  if (response?.status === 200 || response?.status === 204) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    return true;
  }
  throw new Error("Logout API failed");
},
  registerAdmin: async (data) => apiService.create("backend/auth/register-user-admin", data),
  register: async (data) => apiService.create("auth/register", data),
  resendOtp: (login) => {
    const fd = new FormData();
    fd.append("login", login);
    return apiService.create("auth/resend-otp", fd);
  },
  // ✅ VERIFY OTP (ONLY login + otp)
  verifyOtp: (login, otp) => {
    const fd = new FormData();
    fd.append("login", login);
    fd.append("otp", otp);
    return apiService.create("auth/verify-otp", fd);
  }, 
  // changePassword: async (data) => apiService.create("backend/auth/user-change-password", data),


  changePasswordUser: async (data) => apiService.create("backend/auth/user-change-password", data),
  changePassword: async (data) => apiService.create("backend/auth/change-password", data),  
 
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },
  isTokenExpired: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
    
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  },
getCurrentUser: () => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;  
  try {
    return JSON.parse(userStr);
  } catch (err) {
    console.error("Invalid user data in localStorage");
    return null;
  }
},
 isLoggedIn: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      localStorage.removeItem(USER_KEY);
      return false;
    }
    try {
      const decoded = jwtDecode(token);
      if (!decoded?.exp) {
        return true;
      }
      const isExpired = decoded.exp * 1000 < Date.now();
      if (isExpired) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        return false;
      }
      return true;
    } catch (error) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      return false;
    }
  },
};
export default authService;